/* eslint-disable array-callback-return */
import Table from "@/components/Table/table";
import {
  MotifButton,
  MotifCheckbox,
  MotifIcon,
  MotifErrorMessage,
  MotifModal,
  MotifModalBody,
  MotifModalFooter,
  MotifModalHeader,
  MotifProgressLoader,
} from "@ey-xd/motif-react";
import { useEffect, useState } from "react";

import {
  useGetDataSourceSummaryViewApiDataQuery,
  useDeleteDataSourceMutation,
} from "./calculationStepReducer";
import { ENTITLEMENT, SETTLEMENT } from "./Form/Constant";
import FormModal from "./FormModal/FormModal";
import { IconoirWarningTriangle } from "@ey-xd/motif-icon";
import FormModalNew from "./FormModal/FormModalNew";
import { useTranslation } from "react-i18next";
import { havingAddPermission, havingDeletePermission, havingEditPermission } from "@/utility/common";
import { CANCEL_BUTTON_VARIANT, CREATE_BUTTON_VARIANT, GetCommonDeleteImgButton, YES_BUTTON_VARIANT } from "@/components/Images/CommonImages";
import { useNavigate, useParams } from "react-router-dom";
import { useTrans } from "@/components/Functions/dateFunc";

type DataSourceProps = {
  resolvedStatus: boolean;
  caseId: string;
  stepId: string;
  stepData:any;
  StepDataSource?: string[];
};

export const DataSource = ({
  resolvedStatus,
  caseId,
  stepId,
  StepDataSource,
  stepData
}: DataSourceProps) => {
    const { distributionId } = useParams<{
      distributionId: string;
    }>();
  const [isRefetch, setIsRefetch] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const [createFormModal, setCreateFormModal] = useState(false);
  const [formData, setFormData] = useState<any>(null);
  const [editId, setEditId] = useState("");
  const [deleteEntityName, setDeleteEntityName] = useState<any>("");
  const {t}=useTranslation()
  const nav=useNavigate()
  const TitleComplement = () => {
    return (
      havingAddPermission(StepDataSource || [])? <MotifButton
        onClick={() => {
          setCreateFormModal(true);
          setFormData(null);
          setEditId("");
        }}
        size="small"
        type="submit"
        variant={CREATE_BUTTON_VARIANT}
        disabled={resolvedStatus}
      >
        {t("pages.distributions.distributionStepsTab.dataSourceTab.createNewDataSource")}
      </MotifButton>:<></>
    );
  };

  const handleEdit = (data: string) => {
    setFormData(data);
    setIsVisible(true);
  };

  const { data, refetch, isLoading, error,isFetching } =
    useGetDataSourceSummaryViewApiDataQuery(stepId);

  const headerData = {
    title: "Data Sources",
    description: "Descriptive text that describes your page or content.",
  };

  useEffect(() => {
    if (isRefetch) {
      refetch();
      setIsRefetch(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRefetch]);

  const sourceData: any[] = [];
  if (data && data.length > 0) {
    // eslint-disable-next-line array-callback-return
    data.map((item: any) => {
      let obj = {
        dataSource: "",
        sourceManualDataSourceName: "",
        distribution: "",
        distributionId:undefined,
        stepName: "",
        weight: "",
        entitlement: "",
        applicableClasses: "",
        stepDataSourceId: "",
        sourceCalculationStepName: "",
        sourceCalculationStepId:undefined,
        sourceDistributionName: "",
        sourceManualDataSourceId:undefined,
        sourceDistributionId:""
      };
      const PriorStep = item?.dataSourceName === "PriorStep";
      if (PriorStep) {
        obj.dataSource = item?.dataSourceName ? item?.dataSourceName : "-";
        obj.sourceManualDataSourceName = item.sourceManualDataSourceName
          ? item.sourceManualDataSourceName
          : "-";
        obj.distribution = item.distribution ? item.distribution : "-";
        obj.stepName = item.stepName ? item.stepName : "-";
        obj.weight = (item.weight!==null && item?.weight!==undefined && item?.weight!=="")  ? item.weight : "-";
        obj.entitlement = item.isEntitlement ? ENTITLEMENT : SETTLEMENT;
        obj.applicableClasses = item.isFilterApplicableClasses
          ? item.isFilterApplicableClasses
          : "-";
        obj.sourceCalculationStepName = item.sourceCalculationStepName
          ? item.sourceCalculationStepName
          : "-";
        obj.stepDataSourceId = item.stepDataSourceId
          ? item.stepDataSourceId
          : "-";
        obj.sourceDistributionName = item.sourceDistributionName
          ? item.sourceDistributionName
          : "-";
          obj.sourceDistributionId = item?.sourceDistributionId;
          obj.sourceManualDataSourceId = item?.sourceManualDataSourceId;
          obj.sourceCalculationStepId = item?.sourceCalculationStepId;
          obj.distributionId = item?.distributionId;

      } else {
        obj.dataSource = item?.dataSourceName ? item?.dataSourceName : "-";
        obj.sourceManualDataSourceName = item.sourceManualDataSourceName
          ? item.sourceManualDataSourceName
          : "-";
        obj.distribution = "-";
        obj.stepName = "-";
        obj.weight = (item.weight!==null && item?.weight!==undefined ) ? item.weight : "-";
        obj.entitlement = "-";
        obj.applicableClasses = item.isFilterApplicableClasses
          ? item.isFilterApplicableClasses
          : "-";
        obj.sourceCalculationStepName = "-";
        obj.stepDataSourceId = item.stepDataSourceId ? item.stepDataSourceId : "-";
          obj.sourceDistributionName = "-";
          obj.sourceManualDataSourceId = item?.sourceManualDataSourceId

      }
     
      sourceData.push(obj);
    });
  }

  const [deleteDataSource,{isLoading:deleteLoading}] = useDeleteDataSourceMutation();
  const transFunction=useTrans(
    t,
    t("pages.distributions.distributionStepsTab.dataSourceTab.deleteWarningMessage", {
      deleteEntityName: deleteEntityName,
    }),
    "deleteEntityName"
  )
  async function deleteDataSourceAction(dataSourceId: string) {
    const response = await deleteDataSource(dataSourceId);
    if (response.hasOwnProperty("data")) {
      refetch();
    } else {
      console.log("Error in deleting data source");
    }
    setShowModal(false);

  }

  const ActionsCellRenderer = (params: any) => {
    return (
      <>
          {havingDeletePermission((StepDataSource || [])) &&
          <GetCommonDeleteImgButton
          onClick={() => {
            setShowModal(true);
            setDeleteId(params?.data?.stepDataSourceId);
            setDeleteEntityName(params?.data?.dataSource);
          }}
          disabled={resolvedStatus}
          >

          </GetCommonDeleteImgButton>
         }
        {/* {havingEditPermission(StepDataSource || []) && <div className="pad-r-10">
          <MotifButton
            size="small"
            disabled={resolvedStatus}
            variant="secondary"
            onClick={() => {
              setEditId(params?.data?.stepDataSourceId);
              handleEdit(params?.data);
            }}
          >
            <MotifIcon fill="none" iconFunction={contentIcCreate24px} />
          </MotifButton>
        </div>} */}
      </>
    );
  };

  const ApplicableClassesRenderer = (params: any) => {
    return (
      <>
        <div className="pad-r-10">
          <MotifCheckbox
            id="checkbox-example"
            name="checkbox-example"
            onChange={function Ua() {}}
            value="checkbox-result-example"
            checked={params?.data?.applicableClasses === true ? true : false}
          >
            <span></span>
          </MotifCheckbox>
        </div>
      </>
    );
  };

  const columnDataSourceDefs = [
    {
      field: "dataSource",
      headerName: t("pages.distributions.distributionStepsTab.dataSourceTab.columnDetails.column1"),
      sortable: true,
      unSortIcon: true,
      sort: "asc",
      flex: 1,
      minWidth: 150,
      cellRenderer: function (params: any) {
        return <div 
        style={{cursor: havingEditPermission(StepDataSource || []) ? "pointer" : "default"}}
        onClick={()=>{
          if(havingEditPermission(StepDataSource || [])){
            setEditId(params?.data?.stepDataSourceId);
            handleEdit(params?.data);
          }

        }} className={havingEditPermission(StepDataSource || [])?"text-bold-underline":""}>{params?.data.dataSource}</div>;
      },
    },
    {
      field: "sourceManualDataSourceName",
      headerName: t("pages.distributions.distributionStepsTab.dataSourceTab.columnDetails.column2"),
      flex: 1,
      minWidth: 150,

      cellRenderer: function (params: any) {
        return <div 
        style={{cursor: params?.data?.sourceManualDataSourceId? "pointer" : "default"}}
        onClick={()=>{
          if(params?.data?.sourceManualDataSourceId){
            nav(`/case/${caseId}/manual-data-source-edit/${params?.data?.sourceManualDataSourceId}?navigatedFrom=distributionStepSummary&distributionStepId=${stepId}&distributionStepName=${stepData.stepName}&distributionId=${distributionId}`);
          }

        }} className={params?.data?.sourceManualDataSourceId?"text-bold-underline":""}>{params?.data.sourceManualDataSourceName}</div>;
      },
    },
    {
      field: "sourceDistributionName",
      headerName:t("pages.distributions.distributionStepsTab.dataSourceTab.columnDetails.column3"),
      flex: 1,
      minWidth: 150,

      cellRenderer: function (params: any) {
        return <div 
        style={{cursor: params?.data?.dataSource === "PriorStep"? "pointer" : "default"}}
        onClick={()=>{
          if(params?.data?.dataSource === "PriorStep"){
            nav(`/case/${caseId}/distribution/${params?.data?.sourceDistributionId}`);
          }

        }} className={params?.data?.dataSource === "PriorStep" ?"text-bold-underline":""}>{params?.data.sourceDistributionName}</div>;
      },
    },
    {
      field: "sourceCalculationStepName",
      headerName: t("pages.distributions.distributionStepsTab.dataSourceTab.columnDetails.column4"),
      flex: 1,
      minWidth: 150,

      cellRenderer: function (params: any) {
        return <div 
        style={{cursor: params?.data?.dataSource === "PriorStep"? "pointer" : "default"}}
        onClick={()=>{
          if(params?.data?.dataSource === "PriorStep"){
            nav(`/case/${caseId}/distribution/${params?.data?.sourceDistributionId}/calculation-step/${params?.data?.sourceCalculationStepId}/step-summary`);
          }

        }} className={params?.data?.dataSource === "PriorStep" ?"text-bold-underline":""}>{params?.data.sourceCalculationStepName}</div>;
      },
    },
    {
      field: "weight",
      headerName: t("pages.distributions.distributionStepsTab.dataSourceTab.columnDetails.column5"),
      flex: 1,
      minWidth: 150,

      // headerClass:"stepHeaderClass",
      // cellClass:"align-right"
    },
    {
      field: "entitlement",
      headerName: t("pages.distributions.distributionStepsTab.dataSourceTab.columnDetails.column6"),
      flex: 1,
      minWidth: 150,

    },
    {
      field: "applicableClasses",
      headerName: t("pages.distributions.distributionStepsTab.dataSourceTab.columnDetails.column7"),
      flex: 1,
      cellRenderer: ApplicableClassesRenderer,
      minWidth: 140,

    },
    {
      cellRenderer: ActionsCellRenderer,
      field: "action",
      headerName: "",
      flex: 1,
      sortable: false,
      cellClass: "align-right",
      minWidth: 60,

    },
  ];

  if (error) {
    return (
      <MotifErrorMessage
        style={{
          textAlign: "center",
          display: "block",
          alignItem: "center",
        }}
      >
{t("global.globalNotifications.wentWrong")}      </MotifErrorMessage>
    );
  }

  if (isLoading) {
    return <MotifProgressLoader show variant="default" />;
  }

  return (
    <>
      <div>
        {isLoading ? (
          <MotifProgressLoader show variant="default" className="mar-b-20" />
        ) : (
          <div className="mar-b-20 mar-t-20">
            <MotifModal
              onClose={() => setShowModal(false)}
              show={showModal}
              focusTrapOptions={{
                tabbableOptions: {
                  displayCheck: "none",
                },
              }}
            >
              <div className="confirmationModalWrapper creditor_disabling_model">
                <MotifModalHeader
                  headerIcon={
                    <>
                      <span
                        style={{
                          backgroundColor: "rgb(252, 245, 243)",
                          borderRadius: "50px",
                          padding: "5px 8px 2px 8px",
                        }}
                      >
                        <MotifIcon
                          iconFunction={IconoirWarningTriangle}
                          strokeWidth="1"
                          size="15"
                          stroke="red"
                        />{" "}
                      </span>
                      <span
                        style={{
                          fontSize: 16,
                          display: "block",
                          width: "100%",
                          marginLeft: "10px",
                        }}
                      >
{t("global.globalNotifications.warning")}                      </span>
                    </>
                  }
                ></MotifModalHeader>

                <MotifModalBody style={{ paddingTop: "0px" }}>
                  <span style={{ fontWeight: "300" }}>
                  {transFunction}
                  </span>
                </MotifModalBody>
                <MotifModalFooter>
                  <MotifButton
                    size="small"
                    type="submit"
                    variant={YES_BUTTON_VARIANT}
                    style={{
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                    }}
                    onClick={() => {
                      deleteDataSourceAction(deleteId);
                    }}
                    loading={deleteLoading}
                  >
                    {t("global.globalActions.yes")}   
                  </MotifButton>
                  <MotifButton
                    className=""
                    onClick={() => setShowModal(false)}
                    size="small"
                    type="button"
                    variant={CANCEL_BUTTON_VARIANT}
                  >
                     {t("global.globalActions.cancel")}   
                  </MotifButton>
                </MotifModalFooter>
              </div>
            </MotifModal>
            <Table
              columnDefs={columnDataSourceDefs}
              cellRenderers={isFetching?[]:sourceData}
              TitleComplement={TitleComplement}
              title={"pages.distributions.distributionStepsTab.dataSourceTab.tableTitle"}
              description={
                "pages.distributions.distributionStepsTab.dataSourceTab.tableDescription"              }
              caseRenderers={headerData}
              pagination={false}
              overlayNoRowsTemplate={isFetching?t("global.globalNotifications.loadingMessage"):t("global.globalNotifications.noRecords")}
            />
          </div>
        )}
        {
          isVisible && (
            <FormModal
            isVisible={isVisible}
            setIsVisible={setIsVisible}
            formData={formData}
            caseId={caseId}
            stepId={stepId}
            setIsRefetch={setIsRefetch}
            setFormData={setFormData}
            editId={editId}
            resolvedStatus={resolvedStatus}
          />
          )
        }
        {
          createFormModal && (<FormModalNew
            isVisible={createFormModal}
            setIsVisible={setCreateFormModal}
            caseId={caseId}
            stepId={stepId}
            setIsRefetch={setIsRefetch}
            setFormData={setFormData}
          />
          )}
        
      </div>
    </>
  );
};
